var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17 18.4316H13L8.54999 21.3917C7.88999 21.8317 7 21.3616 7 20.5616V18.4316C4 18.4316 2 16.4316 2 13.4316V7.43164C2 4.43164 4 2.43164 7 2.43164H17C20 2.43164 22 4.43164 22 7.43164V13.4316C22 16.4316 20 18.4316 17 18.4316Z",
    fill: "#979797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 12.1113C11.5898 12.1113 11.2498 11.7713 11.2498 11.3613V11.1514C11.2498 9.99137 12.0998 9.42136 12.4198 9.20135C12.7898 8.95135 12.9098 8.78136 12.9098 8.52136C12.9098 8.02136 12.4998 7.61133 11.9998 7.61133C11.4998 7.61133 11.0898 8.02136 11.0898 8.52136C11.0898 8.93136 10.7498 9.27136 10.3398 9.27136C9.92984 9.27136 9.58984 8.93136 9.58984 8.52136C9.58984 7.19136 10.6698 6.11133 11.9998 6.11133C13.3298 6.11133 14.4098 7.19136 14.4098 8.52136C14.4098 9.66136 13.5698 10.2313 13.2598 10.4413C12.8698 10.7013 12.7498 10.8714 12.7498 11.1514V11.3613C12.7498 11.7813 12.4098 12.1113 11.9998 12.1113Z",
    fill: "#979797"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.6016C11.58 14.6016 11.25 14.2616 11.25 13.8516C11.25 13.4416 11.59 13.1016 12 13.1016C12.41 13.1016 12.75 13.4416 12.75 13.8516C12.75 14.2616 12.42 14.6016 12 14.6016Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.0723e1c7c56094a42252499ff0185a74.svg";
export { ForwardRef as ReactComponent };